import { render, staticRenderFns } from "./VideoGallery.vue?vue&type=template&id=2ad2bbeb&scoped=true"
import script from "./VideoGallery.vue?vue&type=script&lang=js"
export * from "./VideoGallery.vue?vue&type=script&lang=js"
import style0 from "./VideoGallery.vue?vue&type=style&index=0&id=2ad2bbeb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad2bbeb",
  null
  
)

export default component.exports